/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';

import { IIconNamePathPair } from '../core/models/icon-name-path-pair.interface';
import { MapIconRegistryService } from '../core/services';

const icCircleShape = 'assets/images/drawing-controls/circle-shape.svg';
const icRectangleShape = 'assets/images/drawing-controls/rectangle-shape.svg';
const icPolygonShape = 'assets/images/drawing-controls/polygon-shape.svg';
const icCircleShapeGrey = 'assets/images/drawing-controls/circle-shape-grey.svg';
const icRectangleShapeGrey = 'assets/images/drawing-controls/rectangle-shape-grey.svg';
const icPolygonShapeGrey = 'assets/images/drawing-controls/polygon-shape-grey.svg';

@NgModule()
export class GeofenceIconModule {
  private readonly _icons: IIconNamePathPair[] = [
    { name: 'ic-circle-shape', svg: icCircleShape },
    { name: 'ic-rectangle-shape', svg: icRectangleShape },
    { name: 'ic-polygon-shape', svg: icPolygonShape },
    { name: 'ic-circle-shape-grey', svg: icCircleShapeGrey },
    { name: 'ic-rectangle-shape-grey', svg: icRectangleShapeGrey },
    { name: 'ic-polygon-shape-grey', svg: icPolygonShapeGrey }
  ];

  constructor(private readonly _mapIconRegistryService: MapIconRegistryService) {
    this._registerIcons();
  }

  private _registerIcons() {
    this._icons.forEach(icon => this._mapIconRegistryService.addSvgIconByPath(icon));
  }
}
